module.exports = __webpack_public_path__ + "static/media/kitty-confused-banner.742a1cc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/kitty-confused-banner.svg
// module id = 135
// module chunks = 0